export default __webpack_public_path__ + "static/media/669.9a155041.png";